import styled from 'styled-components'

export const PageWrapper = styled.div<{ isReviewStep: boolean }>`
  position: relative;
  min-height: 100vh;
  background: ${props => props.isReviewStep ? props.theme.productSelector.reviewBgColor : props.theme.productSelector.bgColor};
  display: flex;
  flex-direction: column;
`

export const MainHeading = styled.h1`
  ${props => props.theme.css.heading1};
  font-size: 30px;

  &::after {
    content: '';
    display: block;
    width: 40px;
    height: 1px;
    margin: 22px auto;
    background-color: ${props => props.theme.palette.general.strong};
  }
`
